var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[(_vm.newCampaign)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Ativar vale-troca',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"secondary-button":{
      text: 'Salvar rascunho',
      action: _vm.saveDraft,
      isVisible: true,
      isLoading: _vm.loading.saveDraft,
      isDisabled: _vm.anyLoading && !_vm.loading.saveDraft,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.scheduledCampaign)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Salvar alterações',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"extra-button":{
      text: 'Suspender',
      action: _vm.unscheduleVoucher,
      isVisible: true,
      isLoading: _vm.loading.unscheduleVoucher,
      isDisabled: _vm.anyLoading && !_vm.loading.unscheduleVoucher,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.activeCampaign)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Salvar alterações',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"extra-button":{
      text: 'Finalizar',
      action: _vm.finalizeVoucher,
      isVisible: true,
      isLoading: _vm.loading.disableDraft,
      isDisabled: _vm.anyLoading && !_vm.loading.saveDraft,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):(_vm.finishedCampaign)?_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Duplicar',
      action: _vm.clone,
      isVisible: true,
      isLoading: _vm.loading.clone,
      isDisabled: _vm.anyLoading && !_vm.loading.clone,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}}):_c('mf-action-buttons',{attrs:{"primary-button":{
      text: 'Ativar vale-troca',
      action: _vm.saveActive,
      isVisible: true,
      isLoading: _vm.loading.saveActive,
      isDisabled: _vm.anyLoading && !_vm.loading.saveActive,
    },"secondary-button":{
      text: 'Salvar alterações',
      action: _vm.saveDraft,
      isVisible: true,
      isLoading: _vm.loading.saveDraft,
      isDisabled: _vm.anyLoading && !_vm.loading.saveDraft,
    },"cancel-button":{
      text: 'Cancelar',
      action: _vm.redirectCampanhas,
      isVisible: true,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }